import React from 'react';

const ComboChart = () => {
  return <div>ComboChart</div>;
};

export default ComboChart;
